import axios from "axios";
import axiosInstance from "@/lib/axios.config";

// ============ TYPES ============
export interface LoginData {
  login: number;
  password: string;
}

// ============ AUTH ============

export const loginUser = async (userData: LoginData) => {
  const response = await axios.post(
    "https://api.obesitybes.com/public/api/adlogin",
    userData
  );
  return response;
};

// export const signUpUser = async (usersData: LoginData) => {
//   const response = await axios.post(
//     "https://todo-app.pioneeralpha.com/api/users/signup/",
//     usersData
//   );
//   return response;
// };

// export const changePassword = async (changePasswordData: any) => {
//   const response = await axiosInstance.post("/users/change-password/", changePasswordData);
//   return response;
// };


export const userProfile = async () => {
  const response = await axiosInstance.get(`/admin/profile`);
  return response?.data;
};
// export const userProfile = async () => {
//   const response = await axiosInstance.get(`/admin/adminacc`);
//   return response?.data;
// };

// export const todosList = async () => {
//   const response = await axiosInstance.get(`/todos/`);
//   return response?.data?.results;
// };

// export const editAccountForm = async (editAccountData: any) => {
//   const response = await axiosInstance.patch("/users/me/", editAccountData);
//   return response;
// };
// export const postTodosForm = async (postTodoData: any) => {
//   const response = await axiosInstance.post("/todos/", postTodoData);
//   return response;
// };

// export const deleteTodos = async (selectedTodosId: any) => {
//   const response = await axiosInstance.delete(`/todos/${selectedTodosId.id}/`);
//   return response;
// };

// export const editTodosForm = async (selectedTodosId: any, data: any) => {
//   const response = await axiosInstance.patch(
//     `/todos/${selectedTodosId?.id}/`,
//     data
//   );
//   return response;
// };
